import useApiManager from 'networking/ApiManager';
import React, { useEffect, useState, useRef } from 'react';
import {
  CommonAlert,
  CoreButton,
  CoreInputBox,
  Recorder,
  CoreTextArea,
  PrescriptionMedicines,
  Select2DropDown,
  TagSelectPicker,
  ReactSelect,
} from 'whealth-core-web/components';
import { useLocation, useParams } from 'react-router-dom';
import { Button, DatePicker, Input, Modal } from 'rsuite';
import { formulationData, splitArrData, splitArrObjData } from '../Helper';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles
import './quill.css';
import './drawer.css';
import './presDrawer.css';


function AddPrescriptionRecord(props) {
  const {
    onClick,
    setErrors,
    errors,
    dynamicPerscriptionData,
    selectedDepartment,
    selectedDoctor,
    selectedClinic,
    userRole,
    setDynamicPerscriptionData,
    setAlertType,
    setIsShowAlert,
    isShowAlert,
    alertType,
    isNivanCareTeam,
    onRecordingComplete,
    patientName,
  } = props;
  const location = useLocation();

  // -------------------------
  // START RECORDING
  // -------------------------
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [audioUrl, setAudioUrl] = useState(null);
  const [audioBlob, setAudioBlob] = useState(null);
  const [fieldErrors, setFieldErrors] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hasReopened, setHasReopened] = useState(false);
  const timerRef = useRef(null);

  const openDrawerRef = useRef(drawerOpen);


  const mediaRecorderRef = useRef(null);
  const chunksRef = useRef([]);
  const [pms, setPms] = useState({
      vas_score: '',
      is_final: false,
      health_condition: [],
      previous_investigation_report: '',
      principal_complaints: '',
      pain_treatment_history: '',
      final_diagnosis: 0,
      next_checkin_date: null,
      drug_allergies: [],
      mdt_consults_advised: '',
      internal_note:'',
    });

  // ----------------------------
  // Open Drawer + Start Recording
  // ----------------------------
  const openDrawerAndStart = async () => {
    if(!selectedClinic){
      alert("Please select Clinic")
      return
    }
    openDrawerRef.current = true
    setIsPaused(false);
    setHasReopened(true);
    setDrawerOpen(true);

    try {
      // const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: {
          // sampleRate: 32000,
          channelCount: 1,
          autoGainControl: true
          // noiseSuppression: true,
          // echoCancellation: true
        }
      });

      mediaRecorderRef.current = new MediaRecorder(stream, {
        mimeType: "audio/webm;codecs=opus",
        audioBitsPerSecond: 64000
      });
      // mediaRecorderRef.current = new MediaRecorder(stream);
      chunksRef.current = [];

      // mediaRecorderRef.current.ondataavailable = (e) => {
      //   chunksRef.current.push(e.data);
      // };
      mediaRecorderRef.current.ondataavailable = (e) => {
        if (e.data && e.data.size > 0) {
          chunksRef.current.push(e.data);
        }
      };

      mediaRecorderRef.current.onstop = () => {
        const blob = new Blob(chunksRef.current, { type: "audio/webm" });
        const url = URL.createObjectURL(blob);

        setAudioBlob(blob);
        setAudioUrl(url);
        // 🔥 VERY IMPORTANT
        mediaRecorderRef.current.stream
        .getTracks()
        .forEach(track => track.stop());
      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
    } catch (error) {
      alert("Microphone permission denied");
    }
  };

  // ----------------------------
  // Stop Recording
  // ----------------------------
  const stopRecording = () => {
    mediaRecorderRef.current.stop();
    // 🔥 VERY IMPORTANT
    mediaRecorderRef.current.stream
    .getTracks()
    .forEach(track => track.stop());
    setIsRecording(false);
  };

  // ----------------------------
  // Delete Recording
  // ----------------------------
  const deleteRecording = () => {
    setAudioUrl(null);
    setAudioBlob(null);
    setIsRecording(false);
  };

  // ----------------------------
  // Download Recording
  // ----------------------------
  const downloadRecording = (blob) => {
    const safePatientName = (patientName || 'patient').trim().replace(/[^a-zA-Z0-9]+/g, '_');
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${safePatientName}_${Date.now()}.webm`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const pauseRecording = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state === "recording") {
      mediaRecorderRef.current.pause();
      setIsPaused(true);
    }
  };
  
  const resumeRecording = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state === "paused") {
      mediaRecorderRef.current.resume();
      setIsPaused(false);
    }
  };
  

  // ----------------------------
  // Build prescription_data + FormData and call the API
  // ----------------------------
  const submitAudio = (blob, fileName) => {
    setFieldErrors([]);
    let prescription_data = {
      is_new: 1,
      recording:1,
      doctor:selectedDoctor,
      department:selectedDepartment,
      clinic:selectedClinic,
    };
    prescription_data.diagnosis_data = [];
    prescription_data.def_diagnosis_data = [];
    prescription_data.vital_data = { bp: '', pulse: '', temperature: '', respiration: '', height: '', weight: '', bmi: '' };
    prescription_data.pms_data = pms;
    prescription_data.health_condition = [];
    prescription_data.drug_allergies = [];
    prescription_data.medication_data = [];
    prescription_data.investigation_data = [];
    prescription_data.treatment_other_data = [];
    prescription_data.treatment_procedure_data = [];
    prescription_data.imaging_data = [];
    prescription_data.red_alert = [];
    prescription_data.treatment_medication = [];
    prescription_data.imaging_data = [];


    if (dynamicPerscriptionData?.prescription_schema) {
      prescription_data.data = dynamicPerscriptionData.prescription_schema;
    }

    if (dynamicPerscriptionData?.enable_medicine) {
      prescription_data.prescription_medicines = dynamicPerscriptionData.prescription_medicines;
    }

    // -----------------------------
    // 🔥 CREATE FORM DATA TO SEND FILE + JSON
    // -----------------------------
    const formData = new FormData();

    // Add file
    formData.append("recording", blob, fileName);

    // Add JSON data
    formData.append("prescription_data", JSON.stringify(prescription_data));

    // -----------------------------
    // 🔥 CALL THE API
    // -----------------------------
    onClick(formData,false,true); // send formData, NOT JSON
  };

  // ----------------------------
  // Submit Recording
  // ----------------------------
  const submitRecording = () => {
    if (!audioBlob) {
      alert("Please record before submitting.");
      return;
    }

    submitAudio(audioBlob, "prescription_recording.webm");

    // 🔥 DOWNLOAD THE AUDIO RECORDING
    downloadRecording(audioBlob);

    setDrawerOpen(false);
  };
  // -------------------------
  // STOP RECORDING
  // -------------------------

  useEffect(() => {

    if(selectedClinic > 0){
      setIsModalOpen(true);
      setHasReopened(false);
      openDrawerRef.current = false
    }

  }, [selectedClinic]);

  const closeModal = () => {
    setIsModalOpen(false);
  
    // if (!hasReopened) {
    //   timerRef.current = setTimeout(() => {
    //     // latest name value check
    //     if (!openDrawerRef.current) {
    //       setIsModalOpen(true);
    //       setHasReopened(true);
    //     }
    //   }, 30000);
    // }
  };
  
  useEffect(() => {
    return () => clearTimeout(timerRef.current); // cleanup
  }, []);

  const duplicateId = location?.state?.id;
  let { id } = useParams();


  const renderFormDetails = () => {
    return (
      <div style={{ 'margin-left': '50px', 'margin-right': '200px' }}>
         {/* NEW */}
         
         {isModalOpen && (
          <div className="confirm-overlay">
            
            <div className="confirm-modal">
              <button className="close-btn-modal" onClick={closeModal}>
                ✖
              </button>
              
              <h5>To create digital prescription , please click on the Start Recording button placed in the footer.</h5>
            </div>
          </div>
        )}
        
        {/* NEW */}
        {showConfirmModal && (
          <div className="confirm-overlay">
            <div className="confirm-modal">
              <h3>Are you sure?</h3>
              <p>Your recording will be lost if you close.</p>

              <div className="confirm-actions">
                <button 
                  className="cancel-btn" 
                  onClick={() => setShowConfirmModal(false)}
                >
                  Cancel
                </button>

                <button 
                  className="yes-btn" 
                  onClick={() => {
                    setShowConfirmModal(false);
                    setDrawerOpen(false);  // 👈 your function
                    stopRecording();
                  }}
                >
                  Yes, Close
                </button>
              </div>
            </div>
          </div>
        )}

        <div className={`chat-popup ${drawerOpen ? "open" : ""}`}>
  
            <div className="chat-popup-header">
              <h4>Record Prescription</h4>
              {/* <button className="close-btn" onClick={() => setDrawerOpen(false)}>✖</button> */}
              <button className="close-btn" onClick={() => setShowConfirmModal(true)}>✖</button>
            </div>

            <div className="chat-popup-body">
              {isRecording ? (
                <div className="recording-section">
                  {isPaused ?
                  <>
                  <div className="paused-icon">
                  ⏸
                  </div>
                  
                  <p>Paused...</p>
                  </>
                  :
                  <>
                  <div className="recording-icon">
                    🎤
                  </div>
                  
                  <p>Recording in progress...</p>
                  </>
                  }

                  

                  <button className="stop-record-btn" onClick={stopRecording}>
                    ⬤ Stop Recording
                  </button>
                  &nbsp;
                  {!isPaused ? (
                      <button className="pause-btn" onClick={pauseRecording}>⏸ Pause</button>
                    ) : (
                      <button className="resume-btn" onClick={resumeRecording}>▶ Resume</button>
                    )}
                </div>
              ) : audioUrl ? (
                <div className="preview-section">
                  <audio controls src={audioUrl} />
                  
                  <div className="preview-actions" style={{"margin-top":"20px"}}>
                    <button className="delete-btn" onClick={() => setShowConfirmModal(true)}>Cancel</button>
                    
                    <button className="submit-btn" onClick={submitRecording}>Save & Process</button>
                  </div>
                </div>
              ) : (
                <p style={{ textAlign: "center" }}>Click Start Recording</p>
              )}
            </div>

            <div className="chat-popup-footer">
              <small>Powered By BrizaAi</small>
            </div>

          </div>
            <button
              className="sticky-record-btn"
                style={{
                  background: "#0d47a1",
                  color: "white",
                  padding: "10px 22px",
                  borderRadius: "8px"
                }}
                onClick={openDrawerAndStart}
              >
              <div className="record-icon">
                <svg width="28" height="28" fill="#fff" viewBox="0 0 24 24">
                  <path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 14 0h-2zM11 18h2v3h-2v-3z"/>
                </svg>
              </div>

              <span className="record-label">Start Recording..</span>
          </button>


        {/* END NEW */}
         <div className='card mt-3 d-none'>
            <div className='card-body'>
              <div className='card-title pt-2 pb-2'>
                <h5>Recording</h5>
              </div>
              <div>
                {/* Button in your UI */}
                <button
                className="sticky-record-btn"
                  style={{
                    background: "#0d47a1",
                    color: "white",
                    padding: "10px 22px",
                    borderRadius: "8px"
                  }}
                  onClick={openDrawerAndStart}
                >
                 <div className="record-icon">
                  <svg width="28" height="28" fill="#fff" viewBox="0 0 24 24">
                    <path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 14 0h-2zM11 18h2v3h-2v-3z"/>
                  </svg>
                </div>

                <span className="record-label">Start Recording</span>
                </button>

          {/* Drawer */}
          <div className={`drawer ${drawerOpen ? "open" : ""}`}>
            <div className="drawer-header">
              <h3>Record Prescription</h3>
              <button onClick={() => setDrawerOpen(false)}>✖</button>
            </div>

            <div className="drawer-body">
              {/* Recording State */}
              {isRecording && (
                <div style={{ textAlign: "center", marginBottom: 20 }}>
                  <div className="pulse-circle">
                  <svg 
                    width="15" 
                    height="15" 
                    viewBox="0 0 24 24" 
                    fill="white"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 14 0h-2zm-5 7a7 7 0 0 0 7-7h-2a5 5 0 0 1-10 0H5a7 7 0 0 0 7 7zm-1 2h2v3h-2v-3z"/>
                  </svg>
                  </div>
                  <br/>
                  <p>Recording in progress...</p>
                  <button className="stop-btn" onClick={stopRecording}>
                  <svg 
                      width="16" 
                      height="16" 
                      viewBox="0 0 24 24" 
                       fill="white"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="12" cy="12" r="8" />
                    </svg> &nbsp;
                    Stop Recording
                  </button>
                </div>
              )}

              {/* Preview State */}
              {!isRecording && audioUrl && (
                <div style={{ textAlign: "center" }}>
                  <audio controls src={audioUrl} style={{ width: "100%" }}></audio>

                  

                  <button className="submit-btn" onClick={submitRecording}>
                    Save & Process
                  </button>
                </div>
              )}

              {/* If no recording yet */}
              {!isRecording && !audioUrl && (
                <>
                <p style={{ textAlign: "center" }}>Recording has not started yet.</p>
                <div style={{ textAlign: "center", marginBottom: 20,marginTop: 20 }}>
                 <button
                  style={{
                    background: "#0d47a1",
                    color: "white",
                    padding: "10px 22px",
                    borderRadius: "8px",
                    float:"center"
                  }}
                  onClick={openDrawerAndStart}
                >
                  Start Recordings
                </button>
                </div>
                </>
                
              )}
            </div>
            {/* 👇 FOOTER */}
            <div className="drawer-footer">
              <small>Powered By <strong>BrizaAi</strong></small>
            </div>
          </div>
        </div>
            </div>
          </div>
          
      </div>
    );
  };

  return <div className='prescription-form'>{renderFormDetails()}</div>;
}

export default AddPrescriptionRecord;
